/**
 * Solo music project — landing page content (/music).
 * Edit URLs and video IDs here.
 */

export interface MusicPlatformLink {
  label: string;
  href: string;
}

export const musicPage = {
  hero: {
    title: 'C.M. Samuels',
    tagline: 'Industrial / EBM solo project from Christopher Samuels',
    listenUrl: 'https://christophersamuels.bandcamp.com/album/after-selection',
    visualizerVideoId: 'RbvE7beHmb0',
    artworkUrl: '/images/cmsamuels-hero.png',
    social: {
      instagram: 'https://instagram.com/c.m.samuels',
      facebook: 'https://www.facebook.com/christopher.m.samuels', // replace with your page URL
      email: 'chris@christophersamuels.com',
    },
  },
  release: {
    title: 'After Selection EP',
    artworkUrl: '/images/after-selection-ep.jpg',
    links: [
      { label: 'Spotify', href: 'https://open.spotify.com/artist/61MLi8hyZNxBZ0qsLuiIPK' },
      { label: 'Bandcamp', href: 'https://christophersamuels.bandcamp.com/album/after-selection' },
      { label: 'Apple Music', href: 'https://music.apple.com/us/album/after-selection-ep/6769373163' },
      { label: 'YouTube', href: 'https://music.youtube.com/playlist?list=OLAK5uy_k0BnbfTkbxcjmFJcv9fL0TleTVW1FlH2Q' },
    ] satisfies MusicPlatformLink[],
  },
  featuredVideo: {
    title: 'Body Interface',
    youtubeVideoId: 'RbvE7beHmb0',
  },
  bio: `Christopher Samuels is a Detroit-area musician and producer working at the intersection of industrial and EBM. After Selection is his solo outlet—lean, rhythmic, and built for the floor.

He also performs in Ritual Howls and Mission to the Sun, bringing years of live performance and studio work into a focused solo practice shaped by machines, tension, and Detroit’s electronic lineage.`,
  contact: {
    email: 'chris@christophersamuels.com',
    label: 'Booking & press',
  },
};

export function youtubeThumbnail(videoId: string): string {
  return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
}

export function youtubeEmbedUrl(videoId: string, autoplay = false): string {
  const params = new URLSearchParams({
    autoplay: autoplay ? '1' : '0',
    rel: '0',
    modestbranding: '1',
  });
  return `https://www.youtube.com/embed/${videoId}?${params}`;
}

export function isValidYoutubeId(id: string): boolean {
  return Boolean(id) && !id.includes('REPLACE');
}
